import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Routes, useLocationPathname } from '@rocketlane/rocket-router';
import { Suspense } from 'react';
import { Loading } from 'components/atoms/loading';
import { useAppShellMode } from 'hooks/use-app-shell-mode';
import { useAccountDataQuery } from 'queries/account';
import { NotFound } from 'routes/404';
import { SecureRoute } from 'routes/route-with-permission-check';
import { ROUTE_PATHS } from 'routes/routes-paths';
import { ResourceManagementPage } from 'routes/vendor/lazy-imports';
import { lazyWithRetry } from 'utils/lazyWithRetry';
const ResourceManagementRmCopilotPage = lazyWithRetry(()=>import('components/pages/resource-management/rm-copilot/rm-copilot-page').then(({ ResourceManagementRmCopilotPage: Component })=>({
            default: Component
        })));
const RM_COPILOT_PATH = `/${ROUTE_PATHS.RESOURCE_MANAGEMENT}/${ROUTE_PATHS.RM_COPILOT}`;
const isRmCopilotPath = (pathname)=>pathname === RM_COPILOT_PATH || pathname.startsWith(`${RM_COPILOT_PATH}/`);
function RmCopilotGate({ children }) {
    var _data_accountMeta_features, _data_accountMeta;
    const { data, isLoading } = useAccountDataQuery();
    if (isLoading) {
        return /*#__PURE__*/ _jsx(Loading, {});
    }
    if (!(data === null || data === void 0 ? void 0 : (_data_accountMeta = data.accountMeta) === null || _data_accountMeta === void 0 ? void 0 : (_data_accountMeta_features = _data_accountMeta.features) === null || _data_accountMeta_features === void 0 ? void 0 : _data_accountMeta_features.rmAgent)) {
        return /*#__PURE__*/ _jsx(NotFound, {});
    }
    return /*#__PURE__*/ _jsx(SecureRoute, {
        rule: "RM_AGENT:WRITE",
        children: children
    });
}
/**
 * In the Nitro Claw shell the RM Agent renders standalone, so the RM data
 * layer (projects, people, placeholders, config) is never mounted. In the
 * Rocketlane shell it renders as a tab inside ResourceManagementMainRoute,
 * which keeps that component — and its queries — mounted across tab switches.
 *
 * The shell is read on every render rather than when the router is built:
 * `createBrowserRouter` runs once at module load, but the web shell toggle
 * switches modes with a client-side navigation and no reload.
 */ const ResourceManagementEntry = ()=>{
    const pathname = useLocationPathname();
    const { isNitroClawShellActive } = useAppShellMode();
    if (isNitroClawShellActive && isRmCopilotPath(pathname)) {
        return /*#__PURE__*/ _jsx(RmCopilotGate, {
            children: /*#__PURE__*/ _jsx(Suspense, {
                fallback: /*#__PURE__*/ _jsx(Loading, {}),
                children: /*#__PURE__*/ _jsxs(Routes, {
                    children: [
                        /*#__PURE__*/ _jsx(Route, {
                            path: `${ROUTE_PATHS.RM_COPILOT}/:conversationId?`,
                            element: /*#__PURE__*/ _jsx(ResourceManagementRmCopilotPage, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "*",
                            element: /*#__PURE__*/ _jsx(NotFound, {})
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(SecureRoute, {
        rule: "RESOURCE_MANAGEMENT:READ",
        children: /*#__PURE__*/ _jsx(ResourceManagementPage, {})
    });
};
export const resourceManagementRoutes = {
    path: `${ROUTE_PATHS.RESOURCE_MANAGEMENT}/*`,
    element: /*#__PURE__*/ _jsx(ResourceManagementEntry, {})
};
